import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '@/views/home-page'

const HomePageProducts = () => import('@/views/home-page/products')
const HomePageCustomer = () => import('@/views/home-page/customer')
const HomePageAbount = () => import('@/views/home-page/abount')
const HomePageForm = () => import('@/views/home-page/contact-form')

Vue.use(Router)

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/home',
    component: HomePage,
  },
  {
    path: '/products',
    component: HomePageProducts,
  },
  {
    path: '/customer',
    component: HomePageCustomer,
  },
  {
    path: '/about',
    component: HomePageAbount,
  },
  {
    path: '/apply',
    component: HomePageForm,
  },
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '*',
    component: HomePage,
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = []

const createRouter = () =>
  new Router({
    mode: 'history',
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
